import React, { useEffect, useState } from 'react';
import { Box, Button, InputAdornment, MenuItem, TextField, Typography, styled } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { LoadCanvasTemplateNoReload, loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha';
import MyDialog from '../../components/dialog-component/my-dialog';
import Iconify from '../../components/Iconify';
import { dispatch } from '../../redux/store';
import { openModal } from '../../redux/slices/authUiSlice';
import { checkIfNumberExist } from '../../utils/formatObject';
import { validatePhoneNumber } from '../../utils/validatePhoneNumber';
import { getOtpErrorMessage } from '../../utils/formatString';
import uuidv4 from '../../utils/uuidv4';
import conObj from '../../utils/connection-assistant';
import useLocales from '../../hooks/useLocales';

const SegmentContainer = styled(Box)({
  display: 'flex',
  border: '1px solid #e0e0e0',
  borderRadius: '999px',
  width: 'fit-content',
  margin: '0 auto',
  overflow: 'hidden',
  padding: '4px',
});

const SegmentButton = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ active }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '8px 16px',
  cursor: 'pointer',
  fontWeight: 500,
  color: active ? '#000' : '#555',
  background: active ? 'linear-gradient(180deg, #f5d08a, #e0a95c)' : 'transparent',
  transition: 'all 0.2s',
}));

const StyledTextField = styled(TextField)({
  marginBottom: '16px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',

    '& fieldset': {
      borderColor: '#e0e0e0',
      borderWidth: '2px',
    },

    '&:hover fieldset': {
      borderColor: '#e0e0e0',
    },

    '&.Mui-focused fieldset': {
      borderColor: '#f0a500',
      borderWidth: '2px',
    },

    '& input': {
      color: '#000', // 👈 FIX: set text color
    },

    '& input::placeholder': {
      color: '#bbb',
      opacity: 1,
    },
  },
});

const GradientButton = styled(Button)(({ theme }) => ({
  padding: '12px',
  borderRadius: '8px',
  textTransform: 'none',
  fontWeight: 600,
  background: 'linear-gradient(180deg, #f5d08a, #e0a95c)',
  color: '#333',

  '&:hover': {
    background: 'linear-gradient(180deg, #eac47a, #d89b4e)',
  },

  '&.Mui-disabled': {
    opacity: 0.6,
    color: '#333',
    background: 'linear-gradient(180deg, #f5d08a, #e0a95c)',
  },
}));

const InputField = ({ icon, endIcon, ...props }) => (
  <StyledTextField
    fullWidth
    {...props}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Iconify icon={icon} width={24} height={24} color="#bbb" />
        </InputAdornment>
      ),
      endAdornment: endIcon && (
        <InputAdornment position="end">
          <Iconify icon={endIcon} width={24} height={24} color="#bbb" />
        </InputAdornment>
      ),
    }}
  />
);

const ForgotPassword = ({ handleClose, handleOpen }) => {
  const { translate } = useLocales();
  const dispatch = useDispatch();
  const [tab, setTab] = useState(0);
  const [countryCode, setCountryCode] = useState('+880');
  const [phone, setPhone] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [captcha, setCaptcha] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [formError, setFormError] = useState({});

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const tabs = [
    { label: 'Account', icon: 'mdi:account-outline' },
    { label: 'Mobile', icon: 'mdi:cellphone' },
  ];

  const countries = [
    { code: '+63', label: 'Philippines', flag: 'https://flagcdn.com/w40/ph.png' },
    { code: '+880', label: 'Bangladesh', flag: 'https://flagcdn.com/w40/bd.png' },
  ];

  // useEffect(() => {
  //   loadCaptchaEnginge(4);
  // }, []);

  // const isValidMobile = () => {
  //   const _errors = {};
  //   let valid = true;

  //   const fullPhone = `${countryCode}${phone}`.replace(/[^0-9+]/g, '');

  //   const invalidPhoneNumber = validatePhoneNumber(fullPhone);

  //   if (!phone?.trim()) {
  //     valid = false;
  //     _errors.phone = 'Phone number is required';
  //   } else if (invalidPhoneNumber) {
  //     valid = false;
  //     _errors.phone = invalidPhoneNumber;
  //   }

  //   if (validateCaptcha(captcha?.trim()) === false) {
  //     valid = false;
  //     _errors.captcha = 'Captcha not match';
  //     setCaptcha('');
  //   }

  //   setFormError(_errors);
  //   return valid;
  // };

  // const onSubmitMobile = async () => {
  //   try {
  //     setError('');
  //     setIsLoading(true);

  //     const fullPhone = `${countryCode}${phone}`.replace(/[^0-9]/g, '');

  //     if (!isValidMobile()) return;

  //     const isExists = await checkIfNumberExist(fullPhone);

  //     if (!isExists) {
  //       throw new Error('Number not exists');
  //     }

  //     let fingerprint = localStorage.getItem('fingerprint');

  //     if (!fingerprint) {
  //       fingerprint = uuidv4();
  //       localStorage.setItem('fingerprint', fingerprint);
  //     }

  //     const response = await conObj.post('otp_request.json', {
  //       no_hp: fullPhone,
  //       fingerprint,
  //       purpose: 'forgotpassword',
  //     });

  //     navigate('/auth/reset-password', {
  //       state: {
  //         otpUuid: response.data?.data?.data?.otp_uuid,
  //         phoneNumber: fullPhone,
  //       },
  //     });
  //   } catch (err) {
  //     console.error(err);
  //     setError(getOtpErrorMessage(err));
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <MyDialog open={handleOpen} close={handleClose} maxSize={'sm'} title={translate('forgot_password')}>
      <Box>
        <Typography sx={{ textAlign: 'center', color: '#666', cursor: 'pointer' }}>
          {translate('agent_step3_2')}
        </Typography>
      </Box>
      {/* Segmented Control */}
      {/* <SegmentContainer sx={{ mb: 4 }}>
        {tabs.map((item, i) => (
          <SegmentButton
            key={i}
            active={tab === i ? 1 : 0}
            onClick={() => setTab(i)}
            sx={{
              borderRadius: '999px',
            }}
          >
            <Iconify icon={item.icon} width={18} />
            {item.label}
          </SegmentButton>
        ))}
      </SegmentContainer> */}

      {/* <InputField
        placeholder={translate('username')}
        icon="mdi:account-outline"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      /> */}

      {/* {tab === 1 && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <TextField
            select
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
            sx={{
              width: 130,
              '& .MuiOutlinedInput-root': {
                borderRadius: '10px',
                backgroundColor: '#f5f5f5',
                color: '#000000',
              },
            }}
            SelectProps={{
              renderValue: (selected) => {
                const country = countries.find((c) => c.code === selected);
                return (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <img src={country?.flag} alt="" style={{ width: 22, height: 16, borderRadius: 3 }} />
                    {selected}
                  </Box>
                );
              },
              MenuProps: {
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                PaperProps: {
                  sx: {
                    borderRadius: '10px',
                    minWidth: 200,
                    backgroundColor: '#fff',
                    color: '#000',

                    '& .MuiMenu-list': {
                      paddingTop: 0,
                      paddingBottom: 0,
                    },
                  },
                },
              },
            }}
          >
            {countries.map((c) => (
              <MenuItem
                key={c.code}
                value={c.code}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  py: 0.5,
                  minHeight: 'unset',
                  height: 36,

                  '&.Mui-selected': {
                    background: 'linear-gradient(90deg, #f7c873, #e6a23c)',
                    color: '#000000',
                  },

                  '&.Mui-selected:hover': {
                    background: 'linear-gradient(90deg, #f7c873, #e6a23c)',
                  },

                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <img
                  src={c.flag}
                  alt=""
                  style={{
                    width: 24,
                    height: 16,
                    borderRadius: 3,
                    objectFit: 'cover',
                  }}
                />

                <Typography fontSize={14}>{c.label}</Typography>

                <Typography fontSize={14} sx={{ marginLeft: 'auto', color: '#333' }}>
                  {c.code}
                </Typography>
              </MenuItem>
            ))}
          </TextField>

          <InputField fullWidth placeholder="0XXXXXXXXX" value={phone} onChange={(e) => setPhone(e.target.value)} />
        </Box>
      )} */}

      <Box
        sx={{ textAlign: 'right', mb: 2, mt: 2 }}
        onClick={() => {
          dispatch(
            openModal({
              view: 'login',
            })
          );
        }}
      >
        <Typography variant="body2" sx={{ textAlign: 'center', color: '#666', cursor: 'pointer' }}>
          {translate('or_return_to_login')}
        </Typography>
      </Box>

      {/* <GradientButton fullWidth disabled={!username && !password}>
        {translate('next')}
      </GradientButton> */}
    </MyDialog>
  );
};

export default ForgotPassword;
